// extracted by mini-css-extract-plugin
module.exports = {"centeredIcon":"Spinner_centeredIcon__y2BJZ"};